// @ts-nocheck
import uniqueId from "@insite/mobius/utilities/uniqueId";
import { useMemo, useState } from "react";

interface UseAccordionStateResult {
    isExpanded: boolean;
    panelId: string;
    toggle: () => void;
    triggerId: string;
}

const useAccordionState = (defaultExpanded = true): UseAccordionStateResult => {
    const [isExpanded, setIsExpanded] = useState(defaultExpanded);
    const triggerId = useMemo(uniqueId, []);
    const panelId = useMemo(uniqueId, []);

    return {
        isExpanded,
        panelId,
        toggle: () => setIsExpanded(prevValue => !prevValue),
        triggerId,
    };
};

export default useAccordionState;
